import PageAbstract from '../PageAbastract'
import store from '@/store'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { RATE_TYPE, CARGO_SOURCES, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache } from '@/utils/cacheManager'
import { Company } from '@/class/model/mdm/Company'
import { getObjectByCache, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getBackUpWarehouseCompany } from '@/api/company'
import { BC_CARGO_TYPE, LCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { User } from '@/class/model/sys/User'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { Office } from '@/class/model/sys/Office'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import lang from '@/lang'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'

const isZh = store.getters.language === 'zh'

export default class SeaBookingBasic extends PageAbstract {
  constructor(job, formData) {
    super(job, formData)
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.isJoinCarrierBookingAgent = Number(cache.config.get('CarrierBookingAgentJoin')) === 1
    this.openProjectConfig = Number(cache.config.get('openProjectConfig')) === 1
    this.isProjectLinkedCustomer = Number(cache.config.get('isProjectLinkedCustomer')) === 1
    this.seMultiSoMode = Number(cache.config.get('SEMultiSoMode')) === 1
    this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
    this.isSpecifiedSalesBusiness = Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1
    this.overseaAgentUsersConfig = Number(cache.config.get('overseaAgentUsersConfig'))
  }

  async loadElement(elementName) {
    let e = null
    switch (elementName) {
      case 'carrierId': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoCompanySelect'))?.default,
          props: {
            no: elementName,
            methodParams: { companyLob: 'seaExport', seaCmp: true, active: true }
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'bookingAgent': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_Company,
            methodParams: { bookingAgent: true, companyLob: 'seaExport', active: true },
            filterable: true,
            staticOptions: null
          },
          convertValue: value => value || 0
        }
        const callback = () => this.refreshBookingAgentAutoComplete(e.props)
        this.joinFieldWatchList('containerLoadType', callback)
        this.joinFieldWatchList('carrierId', callback)
        await callback()
        break
      }
      case 'rateType':
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: [...RATE_TYPE],
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      case 'vesselLine': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = () => this.takeOutVesselLine()
        this.joinFieldWatchList('dischargingPortCode', callback)
        callback()
        break
      }
      case 'cargoSource': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: [...CARGO_SOURCES],
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          },
          linkCheckItems: [{ pageType: UICustomConstants.SEA_BOOKING_BASIC, elementName: 'designationAgent' }]
        }
        break
      }
      case 'cargoType': {
        const cargoType4JobSelect = getSpecificBasicDataFromCache(TYPE_NAMES.basic_data_CargoType).filter(p => p.sea)
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: cargoType4JobSelect,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      }
      case 'loadingAgentId': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoCompanySelect'))?.default,
          props: {
            no: elementName,
            methodParams: { localAgent: true, active: true },
            dataFilterFunction: JobUtils.loadingAgentIdFilter
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'customJobType': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_CutomJobType,
            methodParams: { type: 'SE' },
            filterable: true,
            clearable: true,
            staticOptions: []
          },
          convertValue: value => value || 0
        }
        const callback = () => this.setCustomJobTypeFunc(e.props)
        this.joinFieldWatchList('containerLoadType', callback)
        callback()
        break
      }
      case 'secondaryCustomJobType': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          hide: true,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_CutomJobType,
            cache: false,
            filterable: true,
            staticOptions: []
          },
          convertValue: value => value || 0
        }
        const callback = () => this.setSecondaryCustomJobTypeFunc(e)
        this.joinFieldWatchList('customJobType', callback)
        callback()
        break
      }
      case 'poNo': {
        e = {
          elementName,
          props: {
            no: elementName
          }
        }
        if (this.openProjectConfig) {
          e.component = (await import('@/components/Cargo/Common/cargoProjectSelect'))?.default
          e.props.isLinked = this.isProjectLinkedCustomer
          const callback = () => { e.props.customerId = this.job.customerId }
          this.joinFieldWatchList('customerId', callback)
          callback()
        } else {
          e.component = 'el-input'
        }
        break
      }
      case 'projectName': {
        e = {
          elementName,
          component: 'el-input',
          hide: !this.openProjectConfig,
          disabled: true,
          props: {}
        }
        break
      }
      case 'projectBatch': {
        e = {
          elementName,
          component: 'el-input',
          hide: !this.openProjectConfig,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'portOfDestinationServices': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/basic/portOfDestinationServices'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = () => { e.hide = !this.job.destinationPortService }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('destinationPortService', callback)
        jobCallback()
        callback()
        break
      }
      case 'haulageCompany': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoCompanySelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            methodParams: { truckCmp: true, active: true }
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'warehouseCmp': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoCompanySelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            methodParams: { warehouse: true, active: true }
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'warehouseName': {
        e = {
          elementName,
          component: 'el-select',
          disabled: true,
          props: {
            no: elementName,
            allowCreate: true,
            clearable: true,
            filterable: true
          }
        }
        break
      }
      case 'backUpWarehouse': {
        const companyList = []
        await getBackUpWarehouseCompany().then(res => {
          if (res.data && res.data.length > 0) {
            for (const company of res.data) {
              if (company.branchId === 1 || company.branchId === store.getters.currentOfficeId) {
                companyList.push(company)
              }
            }
          }
        })
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_Company,
            cache: false,
            filterable: true,
            staticOptions: companyList
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'customsDeclaration': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/basic/customsDeclaration'))?.default,
          hide: true,
          props: {
            isEditing: true
          }
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = () => {
          const show = !this.job.masterFlag && this.seMultiSoMode && [LCL_CARGO_TYPE.code, BC_CARGO_TYPE.code].indexOf(this.job.containerLoadType) >= 0
          e.hide = !show
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('containerLoadType', callback)
        jobCallback()
        callback()
        break
      }
      case 'sales': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/sales'))?.default,
          props: {
            no: elementName,
            methodParams: { officeId: this.salesOfficeCheck ? store.getters.currentOfficeId : '', category: 'role', shape: 'sales' }
          },
          convertValue: value => value || 0
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = async() => {
          e.props.staticOptions = null
          if (this.job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code && this.isSpecifiedSalesBusiness) {
            const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId)
            if (company) {
              const salesList = []
              // 如果开启分公司过滤参数，查出来所有分公司
              let officeSaleList
              if (this.salesOfficeCheck) {
                officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', store.getters.currentOfficeId)
              }
              officeSaleList = officeSaleList || []
              const companyUsers = await Company.getCompanyUsers(company.uuid)
              if (companyUsers && companyUsers.length > 0) {
                for (const u of companyUsers) {
                  const userValid = this.job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === this.job.lob
                  if (!u.lob || userValid || u.lob === 'ALL') {
                    const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', u.userId)
                    if (user && user.active) {
                      if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                        if (this.salesOfficeCheck) {
                          for (const obj of officeSaleList) {
                            if (user.userId === obj.userId) {
                              salesList.push(user)
                            }
                          }
                        } else {
                          salesList.push(user)
                        }
                      }
                    }
                  }
                }
              }
              e.props.staticOptions = salesList
            }
          }
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('cargoSource', callback)
        this.joinFieldWatchList('customerId', callback)
        jobCallback()
        await callback()
        break
      }
      case 'overseaOp': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoUserSelect'))?.default,
          props: {
            no: elementName,
            methodParams: { category: 'role', shape: 'overseaOp', active: true }
          },
          convertValue: value => value || 0
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = async() => {
          if (this.isHC) {
            e.props.staticOptions = null
          } else {
            const cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId)
            const overseaAgentDetail = cmp ? await new Company(cmp).getOverseaAgentDetail() : null
            if (overseaAgentDetail) {
              const overseaAgentUsers = await new OverseaAgent(overseaAgentDetail).getOverseaAgentUserList()
              const overseaAgentUsersList = []
              if (overseaAgentUsers && overseaAgentUsers.length > 0) {
                for (const u of overseaAgentUsers) {
                  if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
                    const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', u.userId)
                    if (user && user.active) {
                      if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                        overseaAgentUsersList.push(user)
                      }
                    }
                  }
                }
              }
              e.props.staticOptions = overseaAgentUsersList
            } else {
              if (this.overseaAgentUsersConfig === 1) {
                e.props.staticOptions = null
              } else {
                e.props.staticOptions = []
              }
            }
          }
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('customerId', callback)
        jobCallback()
        await callback()
        break
      }
      case 'characteristic': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/characteristic'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = () => {
          const cargoTypeMatch = getSpecificBasicDataFromCache(TYPE_NAMES.basic_data_CargoType).filter(p => p.sea && p.code === this.job.cargoType)
          if (cargoTypeMatch && cargoTypeMatch.length > 0) {
            e.hide = !cargoTypeMatch[0].showCharacteristics
          } else {
            e.hide = true
          }
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('cargoType', callback)
        jobCallback()
        callback()
        break
      }
      case 'salesCompany': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = async() => {
          const office = await Office.getOfficeById(this.job.salesOffice)
          if (office) {
            this.job.salesCompany = isZh ? office.chineseName : office.englishName
          } else {
            this.job.salesCompany = ''
          }
        }
        this.joinFieldWatchList('salesOffice', callback)
        await callback()
        break
      }
      case 'taxNature': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: TAX_NATURES,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      }
      case 'satisfiedRequests': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/basic/specialRequestsGrid'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = () => { e.props.customerId = this.job.customerId }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('customerId', callback)
        jobCallback()
        callback()
        break
      }
      case 'customsBroker': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_Company,
            methodParams: { customsBroker: true, companyLob: 'seaExport', active: true },
            dataFilterFunction: function(item, inputVal) {
              if (item.cmpIdx === inputVal) {
                return true
              }
              return item.customsBroker && item.seaExport && item.active
            },
            filterable: true
          },
          convertValue: value => value || 0
        }
        const callback = () => {
          const isEditing = this.job.customs && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'customsBroker')
          e.disabled = !isEditing
        }
        this.joinFieldWatchList('customs', callback)
        callback()
        break
      }
      case 'txtWhs': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {
            type: 'textarea',
            rows: 4
          }
        }
        break
      }
      case 'salesChannel': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'trustFromJob': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'quotationNo': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'masterBusinessNo': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'transshipmentTransportationModeCode': {
        const transportationModeInfos = await JobUtils.getTransportationModeAll(this.job)
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            filterable: true,
            staticOptions: transportationModeInfos,
            filterTagNames: ['chineseName', 'englishName', 'code'],
            tagName: 'englishName'
          }
        }
        break
      }
      case 'warehouseStatus': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            options: WarehouseInState.WAREHOUSE_STATE,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      }
      case 'placeOfMblPayment': {
        e = {
          elementName,
          component: 'el-input',
          props: {}
        }
        const callback = () => {
          e.disabled = !(this.job.paymentTermMBL === '3P' || this.job.paymentTermMBL === 'PP')
        }
        this.joinFieldWatchList('paymentTermMBL', callback)
        callback()
        break
      }
      case 'plannerOffice': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoOfficeSelect'))?.default,
          disabled: true,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'csrOffice': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoOfficeSelect'))?.default,
          disabled: true,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'dcOffice': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoOfficeSelect'))?.default,
          disabled: true,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'boxOneWay': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: [
              { label: lang.t('CargoMsg.Cargo_PleaseSelectP'), value: 0 },
              { label: lang.t('CargoMsg.Cargo_OneWay'), value: 1 },
              { label: lang.t('CargoMsg.Cargo_Circulation'), value: 2 }
            ],
            labelField: 'label',
            valueField: 'value'
          }
        }
        break
      }
      case 'cargoSalesId': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoUserSelect'))?.default,
          props: {
            no: elementName,
            methodParams: { category: 'role', shape: 'salesOfGoods' }
          },
          convertValue: value => value || 0
        }
        const callback = async() => {
          e.props.staticOptions = null
          if (this.isSpecifiedSalesBusiness) {
            const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId)
            if (company) {
              const cargoSalesList = []
              const companyUsers = await Company.getCompanyUsers(company.uuid)
              if (companyUsers && companyUsers.length > 0) {
                for (const u of companyUsers) {
                  const userValid = this.job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === this.job.lob
                  if (!u.lob || userValid || u.lob === 'ALL') {
                    const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', u.userId)
                    if (user && user.active) {
                      if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
                        cargoSalesList.push(user)
                      }
                    }
                  }
                }
              }
              e.props.staticOptions = cargoSalesList
            }
          }
        }
        this.joinFieldWatchList('customerId', callback)
        await callback()
        break
      }
      case 'exportControlledProduct': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: SystemConstants.EXPORT_CONTROLLED_PRODUCT,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code',
            clearable: true,
            placeholder: lang.t('SeaExport.PleaseSelect')
          }
        }
        break
      }
      case 'designationAgent': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_Company,
            methodParams: { designationAgent: true, active: true },
            fields: ['englishName'],
            tagName: 'englishName',
            filterable: true
          },
          convertValue: value => value || 0
        }
        const callback = () => {
          e.hide = this.job.cargoSource !== 'NC'
        }
        this.joinFieldWatchList('cargoSource', callback)
        callback()
        break
      }
    }
    if (e) {
      this.elementMap.set(elementName, e)
    }
    return e
  }

  async refreshBookingAgentAutoComplete(props) {
    if (!this.isJoinCarrierBookingAgent || this.job.containerLoadType === 'BB') {
      props.staticOptions = null
      return
    }
    const dataArray = []
    const company = await Company.getCompanyById(this.job.carrierId)
    if (company) {
      company.bookingAgentList = ''
      await new Company(company).getBookingAgentList(true, false)
      const uuidSet = new Set()
      for (const item of company.bookingAgentList) {
        if (!uuidSet.has(item.bookingAgent.uuid)) {
          dataArray.push(item.bookingAgent)
          uuidSet.add(item.bookingAgent.uuid)
        }
      }
    }
    props.staticOptions = dataArray
  }

  // 根据卸货港带出航线
  takeOutVesselLine() {
    this.job.vesselLine = ''
    if (this.job.dischargingPortCode) {
      const port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode)
      if (port) {
        const region = getObjectByCache(TYPE_NAMES.basic_data_Region, 'code', port.region)
        this.job.vesselLine = region ? (isZh ? region.name : region.nameEnglish) : ''
      }
    }
  }

  setCustomJobTypeFunc(props) {
    props.staticOptions = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
  }

  setSecondaryCustomJobTypeFunc(e) {
    if (this.job.customJobType) {
      e.props.staticOptions = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
    } else {
      e.props.staticOptions = []
    }
    e.hide = !this.job.customJobType || e.props.staticOptions.length === 0
  }
}
